import { FormErrors } from '../../hocs/types';
import { getKeys } from '..';

export function makeErrorsSameShapeAsValues<Values, T extends FormErrors<Values>>(errors: T, values: Values & object) {
    const newObject = { ...(errors as object) } as T;

    for (const key of getKeys(errors)) {
        if (!values.hasOwnProperty(key)) {
            delete newObject[key];
        }
    }

    return newObject as FormErrors<Values>;
}

export function removeDuplicates(arr: string[]) {
    return arr.filter((item, i) => {
        return !arr.slice(i + 1).includes(item);
    });
}

type Comparator<T> = (value1: T, value2: T) => boolean;

function strictCompare<T>(value1: T, value2: T) {
    return value1 === value2;
}

function safeFalsyArguments<T>(comparator: Comparator<T>) {
    return (e1: T | undefined, e2: T | undefined) => {
        if (!e1 && !e2 && typeof e1 === typeof e2) {
            return true;
        }

        if (!e1) {
            return false;
        }

        if (!e2) {
            return false;
        }

        return comparator(e1, e2);
    };
}

export function changedIndex<T>(
    arr1: Array<T | undefined>,
    arr2: Array<T | undefined>,
    comparator: Comparator<T> = strictCompare,
) {
    let index: number = -1;

    const decoratedComparator = safeFalsyArguments(comparator);

    for (let i = 0; i < arr1.length; i++) {
        if (!decoratedComparator(arr1[i], arr2[i])) {
            index = i;

            break;
        }
    }

    return index;
}

export const getParameterWithDefault = <T, K extends keyof T, Defaults>(
    skillSettings: T,
    defaults: Defaults,
    parameter: K & keyof Defaults,
) => {
    return typeof skillSettings[parameter] !== 'undefined' ? skillSettings[parameter] : defaults[parameter];
};

export const hasSpecialChars = (text: string) => /[$&+~,:;=?@#|/'"`<>.\\^*()%! ]/.test(text);
